import { render, staticRenderFns } from "./SurveyStatsAll.vue?vue&type=template&id=5d623011&scoped=true"
import script from "./SurveyStatsAll.vue?vue&type=script&lang=js"
export * from "./SurveyStatsAll.vue?vue&type=script&lang=js"
import style0 from "./SurveyStatsAll.vue?vue&type=style&index=0&id=5d623011&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d623011",
  null
  
)

export default component.exports